import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Accordion,
  Button,
  // Nav,
} from "react-bootstrap";
import { FiPlus, FiMinus } from "react-icons/fi";
import { IoArrowForwardOutline } from "react-icons/io5";

import { useNavigate } from "react-router-dom";
import { FiChevronLeft, FiChevronRight, FiClock } from "react-icons/fi";
import { PiGraduationCapLight } from "react-icons/pi";
import { Helmet } from "react-helmet-async";

import CourseBannerImage from "../../assets/publicpageimg/course-detail-images.png";
// import Subjectimg1 from "../../assets/publicpageimg/home-mern.png";
// import Subjectimg2 from "../../assets/publicpageimg/home-frontend.png";
// import Subjectimg4 from "../../assets/home-backend.png";
// import Subjectimg6 from "../../assets/publicpageimg/home-digital.png";
// import Subjectimg3 from "../../assets/publicpageimg/home-uiux.png";
// import Subjectimg5 from "../../assets/publicpageimg/home-data.png";


// old img
// import frontendImg from "../../assets/publicpageimg/frontend-img.png";
// import backnedImg from "../../assets/publicpageimg/backend-img.png";
// import mernImg from "../../assets/publicpageimg/meran-stack-imh.png";

import frontendImg from "../../assets/publicpageimg/frontend-course.png";
import backnedImg from "../../assets/publicpageimg/backend-course.png";

// Who is this course for?
// old img
// import Students from "../../assets/publicpageimg/Students & Freshers.png";
// import Career from "../../assets/publicpageimg/Career Switchers.png";
// import Developers from "../../assets/publicpageimg/Developers Looking.png";

// latest img
import Students from "../../assets/publicpageimg/beginners-students.svg";
import Career from "../../assets/publicpageimg/career-switchers-1.svg";
import Developers from "../../assets/publicpageimg/professionals-looking-upskill.svg";

// old img
// import AIPoweredimg1 from "../../assets/publicpageimg/Apply  Enquire.png";
// import AIPoweredimg2 from "../../assets/publicpageimg/Short Screening Call.png";
// import AIPoweredimg3 from "../../assets/publicpageimg/Select Track & Batch.png";
// import AIPoweredimg4 from "../../assets/publicpageimg/Pay Fee.png";
// import AIPoweredimg5 from "../../assets/publicpageimg/Orientation.png";
// import AIPoweredimg6 from "../../assets/publicpageimg/Start Learning.png";

// latest img
import AIPoweredimg1 from "../../assets/publicpageimg/apply -enquire.svg";
import AIPoweredimg2 from "../../assets/publicpageimg/connect-our-team.svg";
import AIPoweredimg3 from "../../assets/publicpageimg/register-signin.svg";
import AIPoweredimg4 from "../../assets/publicpageimg/enroll-course.svg";
import AIPoweredimg5 from "../../assets/publicpageimg/explore-platform.svg";
import AIPoweredimg6 from "../../assets/publicpageimg/start-learning.svg";


// import HomeBanner from "../../assets/publicpageimg/home-banner.png";
import HomeBanner from "../../assets/publicpageimg/ready-launch-your-web-career.png";
// import Digital from "../../assets/publicpageimg/home-backend.png";

const courses = [
  {
    title: "Backend Development",
    description:
      "Build powerful, scalable, and secure backend applications using Node.js, Express.js, and MongoDB. Learn how to create RESTful APIs, manage databases, implement authentication, and deploy production-ready applications through hands-on projects and real-world development practices. ",
    whatYouLearn: [
      "Build backend applications with Node.js and Express.js",
      "Design and develop RESTful APIs",
      "Work with MongoDB for data modeling and CRUD operations",
      "Implement authentication and authorization using JWT",
      "Manage file uploads, validation, and error handling",
      "Validate user input and handle errors effectively ",
      "Build real-world backend projects from scratch ",
    ],
    imageAlt: "Backend Development",
    image: backnedImg, // you can replace this with your backend-related image
  },
];

const aboutCards = [
  {
    image: AIPoweredimg1,
    title: "Apply / Enquire",
    text: "Click Apply now or WhatsApp us for a free counselling call.",
  },
  {
    image: AIPoweredimg2,
    title: "Connect with Our Team",
    text: "Our team will connect with you, answer your questions, and help choose the right course.",
  },
  {
    image: AIPoweredimg3,
    title: "Register or Signin",
    text: "Create an account or signin to access the learning platform.",
  },
  {
    image: AIPoweredimg4,
    title: "Enroll in Your Course",
    text: "Choose your course and complete enrollment to start your learning journey.",
  },
  {
    image: AIPoweredimg5,
    title: "Explore the Platform",
    text: "Explore the learning dashboard, course structure, and key features.",
  },
  {
    image: AIPoweredimg6,
    title: "Start Learning",
    text: "Access recorded lessons, complete assessments, and build practical skills.",
  },
];

const faqsData = [
  {
    question: "Will I have lifetime access to the course?",
    answer:
      "Yes. Once enrolled, you'll have lifetime access to the recorded course content, allowing you to revisit lessons whenever needed.",
  },
  {
    question: "Does the course include assessments?",
    answer:
      "Yes. Each course includes MCQ assessments to help you evaluate your understanding and reinforce your learning.",
  },
  {
    question: "How is my progress tracked throughout the course?",
    answer:
      "Your progress is automatically tracked as you complete each lesson and MCQ assessment.",
  },
  {
    question: "What support is available during the course?",
    answer:
      "If you have questions or need assistance, our support team is available to help with course-related queries throughout your learning journey.",
  },
  {
    question: "Will I receive downloadable learning resources?",
    answer:
      "No. All learning materials are available within the course, including recorded lessons, practical exercises, and projects.",
  },
];

const projectsData = [
  {
    title: "Learning Management System",
    description:
      "Build a backend for courses with enrollment, progress tracking, role-based access (students, instructors, admins), and secure authentication.",
    tech: ["Node.js", "Express.js", "MongoDB", "JWT"],
  },
  {
    title: "Social Media Backend",
    description:
      "Develop APIs for posts, likes, comments, and user profiles with authentication, efficient database design, and secure user data access.",
    tech: ["Node.js", "Express.js", "MongoDB", "REST APIs"],
  },
  {
    title: "Job Portal Backend",
    description:
      "Build a backend for job listings, applications, and recruiter dashboards with authentication, role-based access, and workflows between recruiters and candidates.",
    tech: ["Node.js", "Express.js", "MongoDB", "JWT"],
  },
];

const curriculumData = [
  {
    title: "Node.js Fundamentals",
    content: [
      "Introduction to Node.js & Advantages",
      "Install Node.js",
      "Hello World in Node.js",
      "Variables",
      "Data Types",
      "Operators",
      "Functions",
      "Arrays and Array Methods",
      "Objects",
      "Loops",
      "Conditions",
      "Global Objects",
      "Modules (Import & Export)",
      "Built-in Modules (fs)",
      "OS and Path Modules",
      "Custom Modules",
    ],
  },
  {
    title: "Asynchronous Programming in Node.js",
    content: [
      "Synchronous and Asynchronous Programming",
      "Callbacks",
      "Callback Hell",
      "Promises",
      "Async and Await",
      "Multiple Async Operations",
      "Error Handling",
      "Async Error Handling",
      "Promise Error Handling",
      "Event Loop",
      "Call Stack",
      "Callback Queue",
    ],
  },
  {
    title: "Express Fundamentals",
    content: [
      "Introduction to Express.js",
      "Creating an Express Server",
      "Routing (GET, POST, PUT, DELETE)",
      "Middleware",
      "REST API Concepts",
      "Request and Response Handling",
      "HTTP Status Codes",
      "CRUD APIs",
    ],
  },
  {
    title: "Backend Architecture and Database Integration",
    content: [
      "MVC Architecture",
      "Controllers, Routes, Models, and Configuration",
      "MongoDB Introduction,MongoDB Setup, Collections and Documents and Connecting Node.js with MongoDB",
      "NoSQL vs SQL",
      "CRUD Operations",
    ],
  },
  {
    title: "Authentication and Database Modeling",
    content: [
      "Mongoose Schemas and Models",
      "Schema Validation",
      "Relationships in MongoDB",
      "User Registration API ,User Login API and Password Hashing with bcrypt",
      "JWT Authentication",
    ],
  },
  {
    title: "File Uploads, Error Handling, and Mini Project",
    content: [
      "File Upload with Multer",
      "Storing File Paths in Database",
      "Mini Project (Authentication + CRUD APIs + MongoDB + Project Structure)",
    ],
  },
];

// const curriculumData = [
//   {
//     title: "Node.js Fundamentals",
//     content: [
//       "Node.js setup & architecture",
//       "Event loop, callbacks, and asynchronous programming",
//       "Modules, npm packages & project structuring",
//       "File system operations",
//       "Error handling & logging",
//     ],
//   },
//   {
//     title: "Express.js & Routing",
//     content: [
//       "Setting up Express.js server",
//       "Routing & middleware",
//       "Request & response handling",
//       "REST API implementation",
//       "Error handling in Express.js",
//     ],
//   },
//   {
//     title: "MongoDB & Database Design",
//     content: [
//       "MongoDB setup & CRUD operations",
//       "Schema design & validation with Mongoose",
//       "Indexes & aggregation pipelines",
//       "Database security & backup strategies",
//       "Integration with Node.js backend",
//     ],
//   },
//   {
//     title: "Authentication & Security",
//     content: [
//       "User authentication using JWT & Passport.js",
//       "Password hashing & security best practices",
//       "Role-based access control",
//       "Data validation & sanitization",
//       "Preventing common security vulnerabilities",
//     ],
//   },
//   {
//     title: "Backend Mini Project",
//     content: [
//       "Design and implement a RESTful API server",
//       "Connect server to MongoDB database",
//       "Integrate authentication and authorization",
//       "Deploy project on AWS or cloud service",
//       "Final testing, optimization & documentation",
//     ],
//   },
// ];

const modulesData = [
  // {
  //   id: 1,
  //   title: "MERN Stack Development",
  //   category: "fullstack",
  //   description:
  //     "Master the MERN stack to build full-stack web applications through hands-on, real-world projects.",
  //   image: mernImg,
  //   route: "/mern-stack",
  //   weeks: "11 - 12",
  //   whatsappMessage:
  //     "Hi, I am interested in the MERN Stack Developer course. I would like enrollment details.",
  // },
  {
    id: 2,
    title: "Frontend Development",
    category: "frontend",
    description:
      "Learn HTML, CSS, JavaScript, and React to build responsive, interactive websites through hands-on projects and practical learning.",
    image: frontendImg,
    route: "/frontend-development",
    weeks: "6 - 7",
    whatsappMessage:
      "Hi, I am interested in the Frontend Developer program. I want to know more details.",
  },

  // {
  //   id: 4,
  //   title: "Digital Marketing",
  //   category: "marketing",
  //   description: "Grow brands using SEO, Ads, and Social Media strategies.",
  //   image: Subjectimg6,
  //   route: "/digital-marketing",
  //   weeks: "5 - 6",
  //   whatsappMessage:
  //     "Hi, I am interested in the Digital Marketing program. Please guide me further.",
  // },
  // {
  //   id: 5,
  //   title: "UI/UX Designer",
  //   category: "frontend",
  //   description:
  //     "Create intuitive, user-centric interfaces with modern UI/UX tools and workflows.",
  //   image: Subjectimg3,
  //   route: "/uiux-designer",
  //   weeks: "9 - 10",
  //   whatsappMessage:
  //     "Hi, I am interested in the UI/UX Designer program at Skilledition. Please share more details about curriculum, duration, and certification.",
  // },
  // {
  //   id: 6,
  //   title: "Data & Analytics",
  //   category: "backend",
  //   description:
  //     "Transform data into actionable insights with modern analytics tools.",
  //   image: Subjectimg5,
  //   route: "/data-analytics",
  //   weeks: "6 - 8",
  //   whatsappMessage:
  //     "Hi, I am interested in the Data & Analytics program at Skilledition. Please share more details about curriculum, duration, and certification.",
  // },
];

const BackendDetails = () => {
  const [activeKey, setActiveKey] = useState("0");
  // const [activeTab, setActiveTab] = useState("beginner");
  const navigate = useNavigate();

  const getVisibleCards = () => {
    if (window.innerWidth <= 576) return 1;
    if (window.innerWidth <= 991) return 2;
    return 3;
  };

  const [visibleCards, setVisibleCards] = useState(getVisibleCards());
  const [startIndex, setStartIndex] = useState(0);

  /* ================= RESIZE LISTENER ================= */
  useEffect(() => {
    const handleResize = () => {
      setVisibleCards(getVisibleCards());
      setStartIndex(0);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  /* ================= SLIDER LOGIC ================= */
  const filteredModules = modulesData;
  const canSlide = filteredModules.length > visibleCards;

  const handleNext = () => {
    if (startIndex < filteredModules.length - visibleCards) {
      setStartIndex((prev) => prev + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  // const courseData = {
  //   beginner: {
  //     title: "Backend Beginner Level",
  //     tag: "Node.js, Express.js, MongoDB fundamentals",
  //     description:
  //       "This level is designed for learners new to backend development, focusing on server-side programming, APIs, and database basics.",
  //     price: "₹10,999",
  //     certificate: "Beginner Backend Completion Certificate",
  //     offer: "₹9,999",
  //   },
  //   intermediate: {
  //     title: "Backend Intermediate Level",
  //     tag: "Node.js, Express.js, MongoDB, REST APIs",
  //     description:
  //       "For learners with basic backend knowledge who want to build dynamic web applications, implement APIs, and handle database operations efficiently.",
  //     price: "₹11,999",
  //     certificate: "Intermediate Backend Completion Certificate",
  //     offer: "₹10,999",
  //   },
  //   advanced: {
  //     title: "Backend Advanced Level",
  //     tag: "Node.js, Express.js, MongoDB, AWS deployment, security",
  //     description:
  //       "Designed for professionals aiming to master scalable backend systems, authentication, cloud deployment, and performance optimization.",
  //     price: "₹12,999",
  //     certificate: "Advanced Backend Completion Certificate",
  //     offer: "₹11,999",
  //   },
  // };

  // const current = courseData[activeTab];

  return (
    <>
      <Helmet>
        <title>
          Skilledition | Backend Development Course – Node.js, Express.js, MongoDB
        </title>

        <meta
          name="description"
          content="Learn backend development with Node.js, Express, REST APIs, authentication, and database integration."
        />

        <link
          rel="canonical"
          href="https://skilledition.in/backend-development"
        />

        {/* Open Graph / Social Share */}
        <meta
          property="og:title"
          content="Skilledition | Backend Development Course – Node.js & APIs"
        />
        <meta
          property="og:description"
          content="Learn backend development with Node.js, Express, REST APIs, authentication, and database integration."
        />
        <meta
          property="og:url"
          content="https://skilledition.in/backend-development"
        />
        <meta
          property="og:image"
          content="https://skilledition.in/seo-banner-backend.png"
        />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Skilledition | Backend Development Course – Node.js & APIs"
        />
        <meta
          name="twitter:description"
          content="Learn backend development with Node.js, Express, REST APIs, authentication, and database integration."
        />
        <meta
          name="twitter:image"
          content="https://skilledition.in/seo-banner-backend.png"
        />
      </Helmet>

      <section className="skilledition-builds-section reveal">
        <Container className="skilledition-builds-section-container">
          <Row className="skilledition-builds-section-row align-items-center">
            {/* LEFT CONTENT */}
            <Col lg={6} className="skilledition-builds-section-left">
              <h1 className="skilledition-builds-section-title">
                Backend Development – Master Server-Side Development
              </h1>

              <p className="skilledition-builds-section-description">
                Master Node.js, Express.js, and MongoDB to build secure,
                scalable backend systems. Learn REST API design, database
                management, authentication, and deployment best practices
                through hands‑on projects. Gain the skills to deliver reliable,
                maintainable server‑side applications that power real‑world
                products.
              </p>

              <div className="skilledition-builds-section-buttons">
                <Button
                  // as="a"
                  // href="https://wa.me/918143879627?text=Hi%20Skilledition%2C%20I%20am%20interested%20in%20your%20Backend%20Development%20Course.%20Please%20share%20details."
                  // target="_blank"
                  // rel="noopener noreferrer"
                  className="skilledition-builds-section-btn-primary"
                  onClick={() => navigate("/signin")}
                >
                  Enroll Now
                </Button>

                <Button
                  className="skilledition-builds-section-btn-secondary"
                  onClick={() => {
                    document
                      .getElementById("curriculum-section")
                      .scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  View Curriculum
                </Button>
              </div>
            </Col>

            {/* RIGHT IMAGE */}
            <Col lg={6} className="skilledition-builds-section-right">
              <img
                src={CourseBannerImage}
                alt="MERN Course Banner"
                className="skilledition-builds-section-image"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-whoaboutpage-section reveal">
        <Container>
          <div className="mb-3 skilledition-whoaboutpage-total-div">
            <h2 className="skilledition-whoaboutpage-title">
              Who is this course for?
            </h2>

            <p className="skilledition-whoaboutpage-desc">
              Designed for students, graduates, aspiring developers, and
              professionals who want to build secure, scalable backend systems
              through hands-on learning and real-world projects.
            </p>
          </div>

          <Row>
            <Col lg={4} md={6} sm={12} className="mb-4">
              <Card className="skilledition-whoaboutpage-card">
                <div className="skilledition-whoaboutpage-icon">
                  <img
                    src={Students}
                    alt="Innovation"
                    className="skilledition-whoaboutpage-icon-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-whoaboutpage-card-title">
                    Beginners & Students
                  </Card.Title>
                  <Card.Text className="skilledition-whoaboutpage-card-text">
                    Perfect for students and beginners who want to learn backend
                    development and build a strong foundation in server-side
                    technologies, databases, and APIs.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12} className="mb-4">
              <Card className="skilledition-whoaboutpage-card">
                <div className="skilledition-whoaboutpage-icon">
                  <img
                    src={Career}
                    alt="Integrity"
                    className="skilledition-whoaboutpage-icon-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-whoaboutpage-card-title">
                    Career Switchers
                  </Card.Title>
                  <Card.Text className="skilledition-whoaboutpage-card-text">
                    Transition into backend development by learning Node.js,
                    Express.js, MongoDB, REST APIs, and modern backend practices
                    through structured, project-based training.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>

            <Col lg={4} md={6} sm={12} className="mb-4">
              <Card className="skilledition-whoaboutpage-card">
                <div className="skilledition-whoaboutpage-icon">
                  <img
                    src={Developers}
                    alt="Student-Centric Approach"
                    className="skilledition-whoaboutpage-icon-img"
                  />
                </div>
                <Card.Body className="p-0">
                  <Card.Title className="skilledition-whoaboutpage-card-title">
                    Professionals Looking to Upskill
                  </Card.Title>
                  <Card.Text className="skilledition-whoaboutpage-card-text">
                    Ideal for developers and professionals looking to enhance
                    backend skills with databases, authentication, APIs, and
                    real-world industry projects.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-learning-section reveal">
        <Container className="text-center skilledition-learning-container">
          <h2 className="skilledition-learning-title">
            Your Learning Journey at Skilledition
          </h2>
          <p className="skilledition-learning-points-section-para">
            Every course follows a structured learning path with high-quality
            recorded lessons, practical projects, and assessments to help you
            build real-world skills step by step.
          </p>
        </Container>
      </section>

      <section className="skilledition-coursesamount-section reveal">
        <Container>
          {/* Tabs */}
          {/* <Row className="justify-content-center mb-4">
            <Col lg="auto">
              <Nav className="skilledition-coursesamount-tabs">
                {[
                  { key: "beginner", label: "Beginner Level" },
                  { key: "intermediate", label: "Intermediate Level" },
                  { key: "advanced", label: "Advanced Level" },
                ].map((tab) => (
                  <Nav.Item key={tab.key}>
                    <Nav.Link
                      className={activeTab === tab.key ? "active" : ""}
                      onClick={() => setActiveTab(tab.key)}
                    >
                      {tab.label}
                    </Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
          </Row> */}

          {/* Content */}
          <Row className="justify-content-center">
            <Col lg={12}>
              <div className="skilledition-coursesamount-card">
                <div className="skilledition-coursesamount-header">
                  <h2>Foundation Level</h2>
                  <Button
                    className="skilledition-download-btn"
                    onClick={() => {
                      document
                        .getElementById("curriculum-section")
                        .scrollIntoView({ behavior: "smooth" });
                    }}
                  >
                    View Curriculum
                  </Button>
                </div>

                <span className="skilledition-coursesamount-tag">
                  Node.js • Express.js • MongoDB
                </span>

                <p className="skilledition-coursesamount-desc">
                  Build a strong foundation in backend development by learning
                  REST APIs, database management, and authentication through
                  guided projects. Gain hands‑on experience creating secure,
                  scalable, and maintainable server‑side applications.
                </p>

                <h5 className="skilledition-coursesamount-details-title border-top pt-3">
                  Level Details
                </h5>
                <div className="skilledition-coursesamount-details">
                  <div>
                    <span>Learning Format</span>
                    <p>Recorded video lessons</p>
                  </div>
                  <div>
                    <span>Course Access</span>
                    <p>Lifetime Access</p>
                  </div>
                  <div>
                    <span>Learning Mode</span>
                    <p>Self-Paced</p>
                  </div>
                  <div>
                    <span>Hands-on Practice</span>
                    <p>Projects & Assignments</p>
                  </div>
                  <div>
                    <span>Certificate</span>
                    <p>Certificate of Completion</p>
                  </div>
                </div>

                <div className="skilledition-coursesamount-footer">
                  <div className="skilledition-coursesamount-price">
                    <h3>₹4,999</h3>
                    {/* <span>Early access offer : {current.offer}</span> */}
                  </div>
                  <Button
                    className="skilledition-apply-btn"
                    onClick={() =>
                      window.open(
                        "https://wa.me/918143879627?text=Hi%20Skilledition%2C%20I%20am%20interested%20in%20your%20Backend%20Development%20Course.%20Please%20share%20details.",
                        "_blank",
                      )
                    }
                  >
                    Apply Now
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-Courses-pagess reveal">
        <Container>
          {courses.map((course, idx) => (
            <Row
              key={course.title}
              className={`skilledition-Courses-page__course-row align-items-center mb-5 ${
                idx % 2 !== 0 ? "flex-row-reverse" : ""
              }`}
            >
              <Col md={6} className="skilledition-Courses-page__text-col">
                <h3 className="skilledition-Courses-page__course-title mb-3">
                  {course.title}
                </h3>
                <p className="skilledition-Courses-page__course-desc mb-3">
                  {course.description}
                </p>

                <h5 className="skilledition-Courses-page__learn-title mb-2">
                  What you'll learn:
                </h5>
                <ul className="skilledition-Courses-page__learn-list mb-3">
                  {course.whatYouLearn.map((item, i) => (
                    <li
                      key={i}
                      className="skilledition-Courses-page__learn-item"
                    >
                      {item}
                    </li>
                  ))}
                </ul>
              </Col>

              <Col md={6} className="skilledition-Courses-page__image-col">
                {/* Placeholder image */}
                <Card.Img
                  src={course.image}
                  alt={course.imageAlt}
                  className="skilledition-Courses-page__course-image"
                />
              </Col>
            </Row>
          ))}
        </Container>
      </section>

      <section
        className="skilledition-weeklycurriculum-section reveal"
        id="curriculum-section"
      >
        <Container>
          <Row>
            <h2 className="skilledition-weeklycurriculum-title">Curriculum</h2>

            <div className="skilledition-weeklycurriculum-right">
              <Accordion
                activeKey={activeKey}
                className="skilledition-weeklycurriculum-accordion"
              >
                {curriculumData.map((item, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={index}
                    className={`skilledition-weeklycurriculum-item ${
                      activeKey === index.toString() ? "active" : ""
                    }`}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString(),
                        )
                      }
                      className="skilledition-weeklycurriculum-header"
                    >
                      <span className="skilledition-weeklycurriculum-question">
                        {item.title}
                      </span>

                      <span className="skilledition-weeklycurriculum-icon">
                        {activeKey === index.toString() ? (
                          <FiMinus />
                        ) : (
                          <FiPlus />
                        )}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className="skilledition-weeklycurriculum-answer">
                      <ul className="skilledition-weeklycurriculum-list">
                        {item.content.map((point, i) => (
                          <li
                            key={i}
                            className="skilledition-weeklycurriculum-list-item"
                          >
                            {point}
                          </li>
                        ))}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          </Row>
        </Container>
      </section>

      <section className="skilledition-projects-section reveal">
        <Container className="skilledition-projects-section-container">
          <h2 className="skilledition-projects-section-title">
            What You Can Build After Internship
          </h2>

          <Row className="skilledition-projects-section-row">
            {projectsData.map((item, index) => (
              <Col lg={4} md={6} key={index}>
                <Card className="skilledition-projects-section-card">
                  <Card.Body className="skilledition-projects-section-card-body">
                    <h5 className="skilledition-projects-section-card-title">
                      {item.title}
                    </h5>

                    <p className="skilledition-projects-section-card-desc">
                      {item.description}
                    </p>

                    <div className="skilledition-projects-section-tech">
                      {item.tech.map((tech, i) => (
                        <span
                          key={i}
                          className="skilledition-projects-section-tech-tag"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="skilledition-enroll-section reveal">
        <Container>
          <Row className="mb-3">
            <Col lg={6}>
              <h2 className="skilledition-enroll-title">How to Enroll</h2>
            </Col>
          </Row>

          <Row>
            {aboutCards.map((item, index) => (
              <Col lg={4} md={6} sm={1} className="mb-4" key={index}>
                <Card className="skilledition-enroll-card">
                  <div className="skilledition-enroll-icon">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="skilledition-enroll-icon-img"
                    />
                  </div>
                  <Card.Body className="p-0">
                    <Card.Title className="skilledition-enroll-card-title">
                      {item.title}
                    </Card.Title>

                    <Card.Text className="skilledition-enroll-card-text">
                      {item.text}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      <section className="skilledition-faqs-section reveal">
        <Container>
          <Row>
            {/* LEFT CONTENT */}
            <Col lg={5} className="skilledition-faqs-left">
              <h2 className="skilledition-faqs-title">
                Frequently asked <br /> questions.
              </h2>
              <p className="skilledition-faqs-desc">
                Skilledition is designed to answer common questions clearly and
                help learners understand our platform easily.
              </p>
            </Col>

            {/* RIGHT FAQ */}
            <Col lg={7} className="skilledition-faqs-right">
              <Accordion
                activeKey={activeKey}
                className="skilledition-faqs-accordion"
              >
                {faqsData.map((faq, index) => (
                  <Accordion.Item
                    eventKey={index.toString()}
                    key={index}
                    className={`skilledition-faq-item ${
                      activeKey === index.toString() ? "active" : ""
                    }`}
                  >
                    <Accordion.Header
                      onClick={() =>
                        setActiveKey(
                          activeKey === index.toString()
                            ? null
                            : index.toString(),
                        )
                      }
                    >
                      <span className="skilledition-faq-question">
                        {faq.question}
                      </span>

                      <span className="skilledition-faq-icon">
                        {activeKey === index.toString() ? (
                          <FiMinus />
                        ) : (
                          <FiPlus />
                        )}
                      </span>
                    </Accordion.Header>

                    <Accordion.Body className="skilledition-faq-answer">
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="skilledition-coursedetail-section reveal">
        <Container>
          {/* HEADER */}
          <div className="skilledition-coursedetail-header">
            <h2 className="skilledition-coursedetail-title">
              Explore More Courses
            </h2>

            {canSlide && (
              <div className="skilledition-coursedetail-arrows">
                <button
                  className="skilledition-coursedetail-arrow"
                  onClick={handlePrev}
                  disabled={startIndex === 0}
                >
                  <FiChevronLeft />
                </button>

                <button
                  className="skilledition-coursedetail-arrow"
                  onClick={handleNext}
                  disabled={startIndex >= filteredModules.length - visibleCards}
                >
                  <FiChevronRight />
                </button>
              </div>
            )}
          </div>

          {/* SLIDER */}
          <div className="skilledition-coursedetail-row">
            <div
              className="skilledition-coursedetail-slider"
              style={{
                transform: `translateX(-${startIndex * (100 / visibleCards)}%)`,
              }}
            >
              {filteredModules.map((module) => (
                <div className="skilledition-coursedetail-col" key={module.id}>
                  <Card className="skilledition-coursedetail-card">
                    <div className="skilledition-coursedetail-image-wrapper">
                      <Card.Img
                        src={module.image}
                        className="skilledition-coursedetail-image"
                      />
                    </div>

                    <Card.Body>
                      <Card.Title className="skilledition-coursedetail-card-title">
                        {module.title}
                      </Card.Title>

                      <Card.Text className="skilledition-coursedetail-text">
                        {module.description}
                      </Card.Text>

                      <div className="skilledition-coursedetail-icons">
                        <span>
                          <FiClock /> {module.weeks} Weeks
                        </span>
                        <span>
                          <PiGraduationCapLight /> Industry Certification
                        </span>
                      </div>

                      <div className="skilledition-coursedetail-btns">
                        <Button
                          className="skilledition-coursedetail-details-btn"
                          onClick={() => navigate(module.route)}
                        >
                          Details
                        </Button>

                        <Button
                          className="skilledition-coursedetail-enroll-btn"
                          // onClick={() =>
                          //   window.open(
                          //     `https://wa.me/918143879627?text=${encodeURIComponent(
                          //       module.whatsappMessage,
                          //     )}`,
                          //     "_blank",
                          //   )
                          // }
                          onClick={() => navigate("/signin")}
                        >
                          Enroll Now <IoArrowForwardOutline />
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          </div>
        </Container>
      </section>

      <section className="skilledition-banner-section reveal">
        <Container>
          <div className="skilledition-banner-section-wrapper">
            <div className="skilledition-banner-section-left">
              <h2 className="skilledition-banner-section-title">
                Ready to Launch <br /> Your Web Career
              </h2>

              <p className="skilledition-banner-section-text">
                Learn skills, build projects, and grow your future with
                Skilledition.
              </p>

              <Button
                className="skilledition-banner-section-btn"
                onClick={() => navigate("/signin")}
              >
                Join Now <IoArrowForwardOutline />
              </Button>
            </div>

            <div className="skilledition-banner-section-right">
              <img
                src={HomeBanner}
                alt="Dashboard Preview"
                className="skilledition-banner-section-image"
              />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default BackendDetails;
